import React from 'react';
import PageHeader from '@layout/PageHeader';
import AppGrid from '@layout/AppGrid';
import RechnungList from '@widgets/Finanzen/FianzenList';
import styles from './Finanzen.module.css';
import TransferList from "@widgets/TransferIndex/TransferList";

const widgets = {
    list: <TransferList />,
};

const TransferIndex = () => {
    return (
        <>
            <PageHeader title="Meine Transfers" className={styles.pageHeader} />
            <AppGrid id="transferIndex" className={styles.grid} widgets={widgets} />
        </>
    );
};

export default TransferIndex;
